export const CONFIG_PERMISSIONS = {
  football: 1,
  tennis: 2,
  cricket: 4,
  live_casino: 8,
  indian_casino: 16,
  commission: 32,
  // Grouped Permission numbers
  sports: 7,
  casino: 24,
};
